import React from "react";

import { BarChart } from '@mui/x-charts/BarChart';

export default function Chart({ data }) {

  function formatToDayMonth(dateStr) {
    const [year, month, day] = dateStr.split('-');
    return `${day}/${month}`;
  }

  function formatNumber(num) {
    if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(1).replace('.0', '') + 'M';
    }

    if (num >= 1_000) {
      return (num / 1_000).toFixed(1).replace('.0', '') + 'K';
    }

    return num?.toString();
  }

  return (
    <div style={{ width: '100%', paddingLeft: 18 }}>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="BarGradient" x1="0%" y1="100%" x2="0%" y2="0%">
            <stop offset="0%" stopColor="#AF00E3" />
            <stop offset="100%" stopColor="#2724D3" />
          </linearGradient>
        </defs>
      </svg>
      <BarChart
        borderRadius={10}
        grid={{ vertical: false, horizontal: true }}
        xAxis={[
          {
            scaleType: 'band',
            data: data?.map((item) => formatToDayMonth(item.createdAt)),
            disableLine: true,
            disableTicks: true,
            categoryGapRatio: 0.96,
          }
        ]}
        yAxis={[
          {
            disableLine: true,
            disableTicks: true,
            tickFontSize: 12,
            valueFormatter: (value) => formatNumber(value), // Converte 5000 → 5K
          }
        ]}
        series={[
          {
            data: data?.map((item) => item.value),
            color: "url(#BarGradient)",
            type: "bar",
          },
        ]}
        height={200}
        sx={{
          "& .css-6w4lf4-MuiLineElement-root": { strokeWidth: 4 }, '& .MuiChartsAxis-directionX': {
            transform: 'translate(0px, 160px)',
          }, '& .MuiChartsAxis-directionY': {
            transform: 'translate(40px, 0px)'
          }, '& .MuiLineElement-root': {
            transform: 'translate(0px, 3px)',
          }
        }}
      />
    </div>
  );
}
